<template>
    <div class="page">
        <div class="gridheader">
            <div class="row">
                <div class="col-md-12 title">
                    <h1 class="mrgn">{{$t('REPORTS')}}</h1>
                    <ul class="list-unstyled">
                        <li v-if="globals.auth == 9" v-bind:class="(routename == 'ReportsDsDaily') ? 'active' : ''">
                            <router-link v-bind:to="'/reportsds/daily'">{{ $t('DSREPORTDAILY')}}</router-link>
                        </li>
                        <li v-if="globals.auth == 9" v-bind:class="(routename == 'ReportsDsMonthly') ? 'active' : ''">
                            <router-link v-bind:to="'/reportsds/monthly'">{{ $t('DSREPORTMONTHLY')}}</router-link>
                        </li>
                        <li v-bind:class="(routename == 'ReportsDsClient') ? 'active' : ''">
                            <router-link v-bind:to="'/reportsds/client'">{{ $t('DSREPORTCLIENT')}}</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>

import
{
    mapGetters
}
from 'vuex'

export default
{
    name: 'Profile',
    data: function()
    {
        return {

        };
    },
    created: function()
    {
        var me = this;
    },
    methods:
    {

    },
    watch:
    {

    },
    computed:
    {
        ...mapGetters([
            'globals'
        ]),
        routename()
        {
            return this.$route.name;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ReportDsHolder.vue